export default class AttachmentInfo {
  id: string;
  fileName: string;
  description: string;
  type: string;

  public constructor(
    id: string,
    fileName: string,
    description: string,
    type: string
  ) {
    this.id = id;
    this.fileName = fileName;
    this.description = description;
    this.type = type;
  }
}
